import { companyAPI } from 'src/core/api/axios';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

type UpdateUserBankInfoParams = {
  userId: string;
  newBankInfo: {
    accountHolderName: string;
    iban: string;
    bic?: string;
    cuc?: string;
    sortCode?: string;
    accountNumber?: string;
    routingNumber?: string;
  };
};

export const useUpdateUserBankInfoForVoP = () => {
  const companyId = useCompanyId();

  const updateUserBankInfo = async ({
    userId,
    newBankInfo,
  }: UpdateUserBankInfoParams) => {
    await companyAPI.post(`/users/${userId}/bank-info`, newBankInfo, {
      companyId,
    });
  };

  return { updateUserBankInfo };
};

